import { Trans } from '@lingui/react/macro';
import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router';
import clsx from 'clsx';
import { Footer } from 'src/apps/footer/Footer';
import { EnterpriseSidebar } from 'src/apps/header/EnterpriseSidebar';
import { Header } from 'src/apps/header/Header';
import { RouteLoadingSpinner, SomethingWentWrong } from 'src/components';

import { createPageMetaTitle } from 'src/utils/createPageMetaTitle';

export const Route = createFileRoute('/_auth/enterprise')({
  staticData: { title: createPageMetaTitle('Enterprise') },
  wrapInSuspense: true,
  errorComponent: ({ error, reset, info }) => (
    <Wrapper>
      <SomethingWentWrong error={error} reset={reset} info={info} />
    </Wrapper>
  ),
  pendingComponent: () => (
    <Wrapper>
      <RouteLoadingSpinner />
    </Wrapper>
  ),
  component: () => (
    <Wrapper>
      <Outlet />
    </Wrapper>
  ),
});

const noSidebarRoutes = ['/enterprise/enroll', '/enterprise/offboarding'];

function Wrapper({ children }: { children: React.ReactNode }) {
  const matches = useMatches();
  const canSeeSidebar = !matches.some((match) =>
    noSidebarRoutes.some((route) => match.pathname.startsWith(route))
  );

  return (
    <div
      className={clsx(
        'flex size-full min-h-screen grow animate-fade-in flex-col items-center justify-between bg-paper-2'
      )}
    >
      <div className="w-full">
        <div className="flex">
          {canSeeSidebar && <EnterpriseSidebar />}
          <div className="relative min-h-screen w-full flex-1 overflow-hidden">
            <Header
              variant="full"
              title={<Trans>Connect for business</Trans>}
              isEnterpriseRoot
            />
            <div className="mt-64 flex min-h-[calc(100vh-200px)] grow flex-col lm:mt-0">
              {children}
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}
